var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-alert',{attrs:{"effect":"dark","closable":false,"show-icon":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.$t('mailing.expired'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }